import type { BookingDetailsState } from '../../domain/types'
import { isDatePast } from '@/scopes/common/domain/utils/dates'

export function isClosedActiveChildGroupBooking(state: BookingDetailsState): boolean {
  return state.isGroupBooking && state.groupSubscriptionModel === 'ClosedActive' && !state.isMasterBooking
}

export function shouldHidePaymentDueDate(state: BookingDetailsState, currentDate: Date = new Date()): boolean {
  const hasDeparted = !!state.rawDepartureDate && isDatePast(state.rawDepartureDate, currentDate)
  return state.isCancelled || hasDeparted || !state.payment?.hasDownPayment
}

export function getNextPaymentDisplayDueDate(state: BookingDetailsState, currentDate: Date = new Date()): string | null {
  if (shouldHidePaymentDueDate(state, currentDate))
    return null

  return state.payment?.nextPayment?.dueDate || null
}
